import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Daily.css';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/db';
import { sortReportItems } from '../utils/helpers';

export default function Daily() {
  const { warehouseId, warehouseName, teamRoles } = useAuth();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Split warehouse Name
  let topName = "";
  let bottomName = "";
  if (warehouseName) {
    const parts = warehouseName.split('-');
    if (parts.length > 1) {
      topName = parts[0].trim();
      bottomName = parts.slice(1).join('-').trim();
    } else {
      topName = warehouseName;
    }
  }

  useEffect(() => {
    if (teamRoles.includes('production')) {
      navigate('/production');
      return;
    }
    if (warehouseId) loadData();
  }, [warehouseId, teamRoles]);

  async function loadData() {
    setLoading(true);
    const [items, transactions] = await Promise.all([
      api.getItems(warehouseId),
      api.getTodayTransactions(warehouseId)
    ]);

    // Filter today's transactions
    // API now returns only today's transactions, so we use it directly
    const todayTrans = transactions;

    // Build map for each item
    const stats = items.map(item => {
      // Find transactions for this item
      // item_id stores the NAME in our implementation (see Home.js) 
      // or we can use the_item_id relation if we populated it.

      let incoming = 0;
      let outgoing = 0;

      // Processing all relevant transactions for this item
      todayTrans.forEach(t => {
        // 1. Standard In/Out
        if (t.item_id === item.name) {
          if (t.type === 'in') incoming += t.quantity;
          else if (t.type === 'out') outgoing += t.quantity;
        }

        // 2. Production Logic
        if (t.type === 'production') {
          // A. If this item is the PRODUCED item (e.g. Sugar 5kg) -> It's Incoming
          if (t.item_id === item.name) {
            incoming += t.quantity;
          }
          // B. If this item is the RAW MATERIAL (Sugar 50kg) -> It's Outgoing (consumed)
          // ID for 50kg: Refactored to Name Check
          if (item.name === 'سكر 50 كيلو') {
            outgoing += (t.consumed_50kg || 0);
          }
        }
      });

      // Current Stock is the LIVE stock right now.
      // Opening (Start of Day) = Current - Incoming + Outgoing
      const current = item.current_stock || 0;
      const opening = current - incoming + outgoing;

      return {
        name: item.name,
        opening,
        incoming,
        outgoing,
        current
      };
    });

    // Filter out rows where all values are 0 (Opening, Incoming, Outgoing, Current)
    const filteredStats = stats.filter(row => {
      // Keep if any value is non-zero
      return row.opening !== 0 || row.incoming !== 0 || row.outgoing !== 0 || row.current !== 0;
    });

    const sortedStats = sortReportItems(filteredStats);

    setReportData(sortedStats);
    setLoading(false);
  }

  return (
    <div className="daily-root" dir="rtl">
      <div style={{ display: 'flex', justifyContent: 'space-between' }} className="no-print">
        <Link to="/home"><button className="btn">الرجوع</button></Link>
        <button className="btn" onClick={() => window.print()}>تحميل PDF</button>
      </div>
      <div className="container">
        {topName && <h2 style={{ textAlign: 'center', margin: '0 0 10px 0', color: '#555' }}>{topName}</h2>}
        <h1>{bottomName ? `${bottomName} ` : ''}تقرير يوم {new Date().toLocaleDateString('ar-EG', { weekday: 'long' })} ({new Date().toLocaleDateString('en-CA')})</h1>
        {loading ? <p>جاري التحميل...</p> : (
          <table id="daily-report-table">
            <thead>
              <tr>
                <th>م</th>
                <th>البيان</th>
                <th>المخزون الافتتاحي</th>
                <th>وارد</th>
                <th>منصرف</th>
                <th>المخزون المتبقي (الرصيد النهائي)</th>
              </tr>
            </thead>
            <tbody>
              {reportData.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.name}</td>
                  <td>{row.opening.toLocaleString('en-US')}</td>
                  <td>{row.incoming.toLocaleString('en-US')}</td>
                  <td>{row.outgoing.toLocaleString('en-US')}</td>
                  <td>{row.current.toLocaleString('en-US')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
